import {
    all,
    put,
    SagaIterator,
    takeEveryCompletedRequest,
    takeEveryErrorRequest,
    takeEveryFatalErrorRequest
} from './core/sagaEffects';
import { ShareRequest, SharingDataRequest } from 'acscp/api/requests';
import { AddNotification, FetchRequest } from 'acscp/actions';
import { ResponseErrorTypes } from 'acscp/api/responses';
import { ErrorDetails } from 'acscp/api/models/errorDetails';
import { ErrorMessage } from 'acscp/api/models/errorMessage';
import { UnshareRequest } from 'acscp/api/requests/unshareRequest';
import { defineMessages } from 'react-intl';
import { NotificationType } from 'acscp/store/notificationState';

const messages = defineMessages({
    share: {
        id: 'components.sharingPage.sharingNotification',
        defaultMessage: 'SHARED'
    },
    unshare: {
        id: 'components.sharingPage.unsharingNotification',
        defaultMessage: 'UNSHARED'
    }
});

export function* shareRefreshSaga(): SagaIterator {
    yield all([
        takeEveryCompletedRequest(ShareRequest,
            (payload: undefined, request: ShareRequest) => refreshShareData(request)),

        takeEveryCompletedRequest(ShareRequest,
            (payload: undefined, request: ShareRequest) => notifyShares(request)),

        takeEveryErrorRequest(ShareRequest,
            (responseType: ResponseErrorTypes, error: ErrorDetails, request: ShareRequest) =>
                refreshShareData(request)),

        takeEveryFatalErrorRequest(ShareRequest,
            (message: ErrorMessage, request: ShareRequest) => refreshShareData(request)),

        takeEveryCompletedRequest(UnshareRequest,
            (payload: undefined, request: UnshareRequest) => refreshShareData(request)),

        takeEveryCompletedRequest(UnshareRequest,
            (payload: undefined, request: UnshareRequest) => notifyUnshares(request)),

        takeEveryErrorRequest(UnshareRequest,
            (responseType: ResponseErrorTypes, error: ErrorDetails, request: UnshareRequest) =>
                refreshShareData(request)),

        takeEveryFatalErrorRequest(UnshareRequest,
            (message: ErrorMessage, request: UnshareRequest) => refreshShareData(request))
    ]);
}

function* notifyShares(request: ShareRequest): SagaIterator {
    yield put(new AddNotification('Share', messages.share, NotificationType.Info));
}

function* notifyUnshares(request: UnshareRequest): SagaIterator {
    yield put(new AddNotification('Unshare', messages.unshare, NotificationType.Info));
}

function* refreshShareData(request: ShareRequest | UnshareRequest): SagaIterator {

    const fetchAction = new FetchRequest(new SharingDataRequest(request.bookingId));

    yield put(fetchAction);
}
